/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
import addCommentTemplate from '../views/add-comment.html'

class TeacherAnswerController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce, $window, $http) {
        let authoring = localStorageService.get("authoringData")
        let qpId = $state.params.qpId
        let studentId = $state.params.studentId
        let userId = localStorageService.get('user_id')
        let schoolId = authoring.school_id
        $scope.isLoading = true
        $scope.fileServerUrl = CONSTANTS.FILE_UPLOAD_URL
        $scope.comment = undefined
        $scope.comment_obj = {}
        $scope.status = undefined
        $scope._is_creator = false
        this.$onInit = () => {
            $scope.comment = undefined
            $scope.comment_obj = {}
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getPrivileges()
            if (authoring) {
                $rootScope.authMenu = true;
                $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject
            } else {
                $state.go("authdashboard")
            }
        }
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "activityList"
        })
        $scope.activityUserPrivilege = {};
        function getPrivileges(){
            try{
                if (userAccess.length > 0) {
                    _.each(userAccess, function(tpObj) {
                        let user_access = {};
                        _.each(tpObj.privilege, function(privObj) {
                            user_access[privObj.name.toLowerCase()] = privObj.status
                        })
                        $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
                    })
                }
            }catch(e){
                console.log(e)
            }
            
        }
        function checkPrivilegeToUpdate(result){
            if($scope.activityUserPrivilege && $scope.activityUserPrivilege.createActivity &&
                $scope.activityUserPrivilege.createActivity.create && result &&
                result.teacher_id && result.teacher_id == userId){
                    $scope._is_creator = true
            }
        }
        authService.callAPI(activityCons.API_GET_STUDENT_ANSWER_DETAILS + qpId + '/' + studentId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    
                    let result = response.result.data.details;
                    checkPrivilegeToUpdate(result)
                    $scope.status = result.activity_status
                    if(result.status){
                        $scope.status = result.status
                    }
                    $scope.student_user_doc = result.student_user_doc
                    let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
                    $scope.my_score = 0
                    $scope.totalmark = 0
                    $scope.quesCount = 0
                    let myScore = 0
                    if(result && result.comment){
                        $scope.comment_obj.comment = result.comment
                    }
                    $scope.isTeacherEvaluation = false
                    _.each(result.consolidatedData, function(sec) {
                            delete sec.questions
                            _.each(sec.answers, function(ans) {
                                if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                    $scope.quesCount++;
                                }
                                $scope.totalmark = ans.total_mark
                                if (!isNaN(ans.my_score)) {
                                    myScore = parseFloat(myScore) + parseFloat(ans.my_score)
                                    myScore = myScore.toFixed(2)
                                    $scope.my_score = myScore
                                }
                            })
                        })
                        /*if ($scope.quesCount > 0 && $scope.questionPaper.status != 'published')
                            $scope.isTeacherEvaluation = true*/
                    $scope.questions = result.consolidatedData;
                    //For teaching plan activity
                    $scope.teachingPlanId = result.plan_id
                    $scope.qpDetails = {
                        question_paper_title: result.question_paper_title,
                        subject: authoring.subject,
                        class: authoring.class,
                        time: result.time,
                        due_date: result.due_date
                    }
                    $scope.isLoading = false
                    setTimeout(() => {
                        $scope.loadLatex()
                    }, 100);
                    setChoice();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
               // toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        })
        //To get school details
        authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                console.log(result)
                $scope.qpHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                    'subject': authoring.subject,
                    'class': authoring.class
                }
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                //error
            }
        })

        function removeSpecialCharacter(value) {
            if (value) {
                value = value.replace(/\\quad/g, "")
                value = value.replace(/\\/g, "")
            }
            return value
        }
        /* Set answered choice is wrong or correct*/
        function setChoice() {
            _.each($scope.questions, function (section) {
                _.each(section.answers, function (data, key) {
                    
                    $scope.total_mark += parseFloat(data.mark)
                    let score = parseFloat(data.my_score)
                    $scope.score += score;
                    if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                        _.each(data.choice, function (choice) {
                            if ($scope.checkingChoiceExists(choice.desc, data)) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                }
                            }
                        })
                    } else if (data.type == 'TF') {
                        _.each(data.choice, function (choice) {
                            if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            }
                        })
                    } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                        let key = 0
                        _.each(data.answer, function (choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'OWQ') {
                        let key = 0
                        _.each(data.answer, function(choice) {
                            /**OWQ auto evaluation of multiple answers starts */
                            // let correctAnswer = removeSpecialCharacter(choice.desc)
                            let correctAnswer = choice.desc
                            let answer_as_array = correctAnswer.split(",")
                            
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if(answer_as_array.length){
                                    for(let a = 0; a < answer_as_array.length; a++){
                                        let one_qb_ans_str = answer_as_array[a]
                                        if(one_qb_ans_str){
                                            one_qb_ans_str = one_qb_ans_str.toLowerCase().trim()
                                            if(studentAnswer.toLowerCase().trim() == one_qb_ans_str){
                                                choice.correct = true
                                                break;
                                            }
                                        }
                                    }
                                }
                                if(!choice.correct){
                                    choice.wrong = true
                                }
                                // if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                //     choice.wrong = true
                                // } else {
                                //     choice.correct = true
                                // }
                                /**OWQ auto evaluation of multiple answers ends */
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'MTF') {
                        data.ans_key = []
                        let key = 0
                        _.each(data.option, function(choice) {
                            let needed = true 
                            if(!choice.question.desc){
                                choice['no_question'] = true
                                needed = false
                            }
                            let correctAnswer = removeSpecialCharacter(choice.answer.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let correct = false
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                if (correctAnswer !== studentAnswer) {
                                    correct = false
                                } else {
                                    correct = true
                                }
                                data.ans_key.push({
                                    desc: data.my_answer[key].desc,
                                    correct: correct,
                                    optImage: data.my_answer[key].optImage,
                                    needed : needed
                                })
                            }
                            key++
                        })
                    } else if (data.type == 'ASLLISTEN') {
                        _.each(data.questions, function (aslListQues) {
                            if (aslListQues.type == 'mcq') {
                                _.each(aslListQues.choice, function (choice) {
                                    if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'tf') {
                                _.each(aslListQues.choice, function (choice) {
                                    if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'fib') {
                                _.each(aslListQues.answer, function (choice, index) {
                                    let correctAnswer = removeSpecialCharacter(choice.desc)
                                    if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                        let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    } else {
                                        choice.wrong = true
                                        if (aslListQues.my_answer != undefined) {
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        } else {
                                            aslListQues.my_answer = []
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'text') {
                                let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                if (aslListQues.my_answer != undefined) {
                                    let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        aslListQues.wrong = true
                                    } else {
                                        aslListQues.correct = true
                                    }
                                } else {
                                    aslListQues.wrong = true
                                    aslListQues.my_answer = 'Not Answered'
                                }
                            }
                        })
                    }
                })
            })
            console.log($scope.questions)
        }
        $scope.checkingChoiceExists = function (choice, data) {
            let isChecked = false;
            if (data.my_answer != undefined) {
                return data.my_answer.indexOf(choice) > -1
            } else {
                return isChecked
            }
        }
        $scope.gotoQpPreview = function () {
            $state.go('qpSummary', {
                qpId: qpId
            })
        }
        $scope.markValidation = (questionId, sectionIndex, section, qnMark) => {
            let answersMarkCount = 0
            _.each(section.answers, function (data) {
                if (parseFloat(data.my_score) > 0) {
                    answersMarkCount++
                }
            })
            if (answersMarkCount > section.mandatory_no) {
                let questionIndex = section.answers.findIndex(i => i._id === questionId)
                section.answers[questionIndex].my_score = 0
                toastr.error(" You have already entered the marks all mandatory question")
                section.answers[sectionIndex]
            };
            let actualScore = 0;
            let totalScore = qnMark
            let questionIndex = $scope.questions[sectionIndex].answers.findIndex(i => i._id === questionId)
            if (questionIndex > -1) {
                actualScore = $scope.questions[sectionIndex].answers[questionIndex].my_score
            }
            if (actualScore > totalScore)
                $scope.questions[sectionIndex].answers[questionIndex].my_score = 0
        }
        $scope.saveMark = function () {
            let errorCount = 0;
            _.each($scope.questions, function (section) {
                _.each(section.answers, function (quest) {
                    //mark_each_qn changed to qn_mark
                    //For individual mark  for each question
                    //Developer-Raziya
                    quest.qn_mark = parseFloat(quest.qn_mark)
                    if (quest.my_score > quest.qn_mark) {
                        quest.mark_error = "Enter the mark less than total mark"
                        errorCount++;
                    }
                })
            })
            if (errorCount > 0) {
                toastr.error("Check the marks")
            } else {
                let requestObj = {
                    questions: $scope.questions,
                    student_id: studentId,
                    question_paper_id: qpId,
                    user_id: userId,
                    authoring_data: authoring,
                    comment : $scope.comment_obj.comment
                }
                console.log(requestObj)
                authService.callAPI(activityCons.API_UPDATE_EXAM_SCORE, "POST", requestObj, function (response) {
                    if (response.result && response.result.data && response.result.data.message) {
                        try {
                            let result = response.result.data.message;
                            toastr.success(result);
                            if ($scope.teachingPlanId !== null) {
                                $state.go("submissionList", {
                                    qpId: qpId
                                })
                            } else {
                                $state.go("viewSubmissionList", {
                                    qpId: qpId
                                })
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        }
        function validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(str);
        }
        $scope.setFilePath = function (img) {
            if (!img) {
                return undefined
            }
            let isValid = validURL(img)
            let new_url = undefined
            if (!isValid) {
                new_url = CONSTANTS.FILE_UPLOAD_URL + img
            } else {
                let splitValidUrl = img.split("uploads")
                if (splitValidUrl && splitValidUrl.length && splitValidUrl.length == 2) {
                    new_url = CONSTANTS.FILE_UPLOAD_URL + "/uploads" + splitValidUrl[1]
                } else {
                    new_url = undefined
                }
            }
            return new_url
        }

        $scope.beautifyFIB = function (question) {
            return question.toString().replace(/_/g, " _______ ")
        }
        let MQ = MathQuill.getInterface(2);
        $scope.loadLatex = function () {
            let questionElements = document.getElementsByClassName('question_desc')
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            })
        }

        $scope.showImagepopUpWithCanvas = (url, answer, question, image_index) => {
            console.log(question['answerImg'][image_index])
            $scope.answerDetails = {
                school_id: schoolId,
                qp_id: qpId,
                question : question,
                student_id: studentId,
                question_id: question._id,
                image_index: image_index,
                current_url : url,
                new_url: "/uploads/dR6YPLMmGngGhysiY/question/file_1589974617305.png"
            }

            var canvas = document.getElementById("canvasArea");
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;

            canvas.width = 650
            canvas.height = 550

            var ctx = canvas.getContext("2d");

            var imageObj = new Image();
            imageObj.onload = function () {
                var maxHeight = 550;
                var maxWidth =  650;

                var height = this.height;
                var width = this.width;

                // calculate the width and height, constraining the proportions
                if (width > height) {
                    if (width > maxWidth) {
                        height = Math.round(height *= maxWidth / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = Math.round(width *= maxHeight / height);
                        height = maxHeight;
                    }
                }
            
                ctx.drawImage(this, 0, 0, width, height);
            };
            imageObj.crossOrigin = 'Anonymous';
            imageObj.src = url;

            document.addEventListener('mousemove', draw);
            document.addEventListener('mousedown', setPosition);
            document.addEventListener('mouseenter', setPosition);

            var pos = { x: 0, y: 0 };
            function setPosition(e) {
                pos.x = e.clientX-10;
                pos.y = e.clientY-60;
            }
            function draw(e) {
                // mouse left button must be pressed
                if (e.buttons !== 1) return;
                ctx.beginPath(); // begin
                ctx.lineWidth = 2;
                ctx.lineCap = 'round';
                ctx.strokeStyle = '#c0392b';
                ctx.moveTo(pos.x, pos.y); // from
                setPosition(e);
                ctx.lineTo(pos.x, pos.y); // to
                ctx.stroke(); // draw it!
            }

            $scope.canvasData = true
            $scope.pdfData = false
            let isValid = validURL(url)
            isValid = true
            if (isValid) {
                $scope.url = $sce.trustAsResourceUrl(url)
                $scope.pdfData = true
            }
        }

        $scope.showImagepopUp = (url) => {
            
            $scope.canvasData = false
            $scope.pdfData = false
            let isValid = validURL(url)
            if (isValid) {
                $scope.url = $sce.trustAsResourceUrl(url)
                $scope.pdfData = true
            }
        }
        $scope.backToHtml = () => {
            $scope.pdfData = false
            $scope.canvasData = false
            $scope.url = undefined
        }

        $scope.saveCanvasImage = () => {
            var canvas = document.getElementById('canvasArea');
            $scope.answerDetails.imgUrl = canvas.toDataURL('image/png');
            console.log($scope.answerDetails)
            authService.callAPI("/v0/traditional/teacher/comment/image", "POST", $scope.answerDetails, function (response) {
                console.log(response)
                let imgUrl = $scope.answerDetails.current_url
                try {
                    imgUrl = response.result.data.imgUrl
                } catch(ex){
                    console.log(ex)
                }
                console.log($scope.answerDetails.question)
                $scope.answerDetails.question['answerImg'][$scope.answerDetails.image_index] = imgUrl
                toastr.success("Updated the image");
            })

        }

        $scope.clearCanvas = (url) => {
            var canvas = document.getElementById("canvasArea");
            canvas.width = 650
            canvas.height = 550

            var ctx = canvas.getContext("2d");
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

            var imageObj = new Image();
            imageObj.onload = function () {
                var maxHeight = 550;
                var maxWidth =  650;

                var height = this.height;
                var width = this.width;

                // calculate the width and height, constraining the proportions
                if (width > height) {
                    if (width > maxWidth) {
                        height = Math.round(height *= maxWidth / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = Math.round(width *= maxHeight / height);
                        height = maxHeight;
                    }
                }
            
                ctx.drawImage(this, 0, 0, width, height);
            };
            imageObj.crossOrigin = 'Anonymous';
            imageObj.src = url;
        }

        $scope.addComment = (questionId, sectionIndex, section, qnMark, isMcq, mcq_question) => {
            showMetadataPopUp(questionId, sectionIndex, section, isMcq, mcq_question)
        }
        function showMetadataPopUp (questionId, sectionIndex, section, isMcq, mcq_question) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'parentScope', 
                'questionId' , 'sectionIndex', 'section', 'questions', 'isMcq', 'mcq_question',
                 AddCommentInAnswerCtrl],
                locals: {
                    parentScope : $scope,
                    questionId : questionId,
                    sectionIndex : sectionIndex,
                    section : section,
                    questions : $scope.questions,
                    isMcq : isMcq,
                    mcq_question : mcq_question
                },
                template: addCommentTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
        }
        $scope.saveCommentInAnswer = (questionId, sectionIndex, section, comment, isMcq, mcq_question) => {
            if(!isMcq){
                let questionIndex = $scope.questions[sectionIndex].answers.findIndex(i => i._id === questionId)
                if($scope.questions[sectionIndex].answers[questionIndex]){
                    $scope.questions[sectionIndex].answers[questionIndex]['comment'] = comment
                }
            }else{
                mcq_question['comment'] = comment
            }
            
        }
        $scope.conertToHtml = function (string) {
            // string = "<span style='color: #89a000'>123</span>"
            return $sce.trustAsHtml(string);

        }
    }
}

export default TeacherAnswerController
class AddCommentInAnswerCtrl {
    constructor($scope, $mdDialog, parentScope, questionId, sectionIndex, section, questions,
        isMcq, mcq_question
        ) {
        $scope.metadata = {}
        $scope.answer = {}
        
        if(!isMcq){
            let questionIndex = parentScope.questions[sectionIndex].answers.findIndex(i => i._id === questionId)
            if(parentScope.questions[sectionIndex].answers[questionIndex]){
                $scope.answer = parentScope.questions[sectionIndex].answers[questionIndex]
            }
        }else{
            $scope.answer = mcq_question
        }
        
        $scope.hide = function() {
          $mdDialog.hide();
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };
        $scope.addComment =  () => {
            parentScope.saveCommentInAnswer(questionId, sectionIndex, section,
                $scope.answer.comment, isMcq, mcq_question)
            $mdDialog.hide();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/teacherAnswerView.js